import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ProfilePhotoComponent } from "./profile-photo.component";

@NgModule({
  declarations: [ProfilePhotoComponent],
  imports: [CommonModule],
  exports: [ProfilePhotoComponent],
})
export class ProfilePhotoModule {}
